import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, Download2Icon, ViewIcon } from 'assets/icons';
import { CallService, GeneralService } from 'services';
import moment from 'moment';
import ViewChat from '../chat/view-chat';

declare var window: any;

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  area_id: '',
  date: '',
};

class AdminCalls extends React.Component<Props> {
  timer: any = undefined;
  targetNode: any = null;
  observer: any = null;

  state = {
    header: [
      'ID',
      'Fecha',
      'Hora de inicio y cierre',
      'Tipo de derecho',
      'Motivo de la consulta',
      'Cliente',
      'C.I',
      'Abogado',
      'Inpre',
      'Gestión',
      'Estatus',
      'Motivo de cancelación',
      '',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    leftOpen: true,
    areas: [],
    visible: false,
    item: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Llamadas Teléfonicas',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
    this.getSelects();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  load = async (withoutLoading: boolean = false) => {
    try {
      const res: any = await CallService.admin.get({
        page: this.state.page,
        user_id: this.props.user?.id,
        ...this.state.form,
        date: this.state.form.date ? moment(this.state.form.date).format('YYYY-MM-DD') : '',
        withoutLoading,
      });

      this.setState({
        data: res.rows,
        last_page: res.count,
      });
    } catch (error) {}
  };

  getSelects = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      area: true,
      withoutLoading: true,
    });

    this.setState({
      areas: res.areas || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    const chat = !!item?.chats?.length ? item.chats[0].chat : null;
    if (!chat) return;
    this.setState(
      {
        visible: true,
        item: chat,
      },
      () => {
        Globals.hideTooltip();
      },
    );
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  download = async () => {
    try {
      const res: any = await CallService.admin.get({
        user_id: this.props.user?.id,
        download: true,
        ...this.state.form,
      });

      if (window.webkit && window.webkit.messageHandlers) {
        const message = 'open_url';
        const sendToNative = {
          message,
          url: Constants.BASE_STORAGE + res.url,
        };
        const stringifiedMessageObj = JSON.stringify(sendToNative);
        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
      } else {
        Print(Constants.BASE_STORAGE + res.url);
      }
    } catch (error) {}
  };

  render() {
    const { visible } = this.state;
    return (
      <div id='admin-calls'>
        <div className={`container-modal-right ${visible ? 'active' : ''}`}>
          {visible && <ViewChat item={this.state.item} onClose={() => this.onClose()} />}
        </div>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-2'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Buscar'
                  label='Nombre o ID'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-2'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de derecho'
                  name='area_id'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-2'>
                <DatePicker
                  label='Fecha'
                  placeholder='Fecha'
                  onChange={(date: Date) => {
                    this.change(
                      {
                        target: {
                          value: date,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Llamadas Teléfonicas'
          data={this.state.data.length}
          header={this.state.header}
          titleRight={
            <>
              {this.state.data.length > 0 && (
                <div className='container-download' onClick={this.download}>
                  <img src={Download2Icon} />
                  <p>Descargar Excel</p>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i?.number}</td>
                <td>{moment(i?.day).format('DD-MM-YYYY')}</td>
                <td>{i?.hour_format}</td>
                <td>{i?.area?.name}</td>
                <td className='description'>
                  {i?.description ? (
                    <Tooltip title={i.description}>
                      <span className='description-text'>{i.description}</span>
                    </Tooltip>
                  ) : (
                    '-'
                  )}
                </td>
                <td>{i?.user?.full_name}</td>
                <td>{i?.user?.full_document}</td>
                <td>{i?.lawyer?.full_name ?? '-'}</td>
                <td>{i?.lawyer?.lawyer_document ?? '-'}</td>
                <td>{i?.management_text ?? '-'}</td>
                <td>{i?.status_text}</td>
                <td className='description'>
                  {i?.cancel_reason ? (
                    <Tooltip title={i.cancel_reason}>
                      <span className='description-text'>{i.cancel_reason}</span>
                    </Tooltip>
                  ) : (
                    '-'
                  )}
                </td>
                {i?.resolved_type === Constants.LAWYER_INTERNAL.NO &&
                i?.status === Constants.CALL_STATUS.RESOLVED ? (
                  <td className='text-center'>
                    <Tooltip title='Ver'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  </td>
                ) : (
                  <td className='text-center'></td>
                )}
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
    sidebar: state.sidebar,
  };
})(AdminCalls);
